var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-home"},[_c('div',{staticClass:"wrapper-main"},[_c('div',{staticClass:"img-logo"}),_c('div',{staticClass:"home-title-text"},[_vm._v(" 공연을 선택하세요 ")]),_c('perform-swiper-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }